import styled, { breakpoints } from '../../../../styles/theme';
import { PriceBoxStyled } from '../PriceBoxStyled';
import { rem } from 'polished';

export const PriceBoxStyledDS = styled(PriceBoxStyled)`
    background-color: ${({ theme }) => theme.colors.grey4};
    .catalogPrice {
        padding: ${rem('13px')} ${rem('8px')};
        .catalogPriceLabel {
            font-size: ${rem('16px')};
            font-weight: normal;
        }
        .catalogPriceAmount {
            font-size: ${rem('16px')};
            font-weight: bold;
            .currencyLabel__suffix--OTR {
                font-size: ${rem('12px')};
            }
        }
    }

    .priceBoxWrapper {
        background-color: ${({ theme }) => theme.colors.grey4};
        .financeLabel {
            font-size: ${rem('12px')};
        }
        .price {
            .cashPrice {
                font-size: ${rem('24px')};
            }
            .monthlyPrice {
                font-size: ${rem('21px')};
                display: flex;
                align-items: center;

                .vertical {
                    font-size: 1rem;
                }
            }
            .priceConjunction span {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
            }
        }

        .priceNotice span {
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
        }
    }

    .currencyLabel__suffix--OTR,
    .currencyLabel__suffix--TTC,
    .currencyLabel__suffix--TTC-monthly {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
    }

    .aprDescription {
        color: ${({ theme }) => theme.colors.primaryHover};
    }
`;
